var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M256.9 260.9V1793H1789V260.9zm1355.4 179.3v75.6l-2-2-770.4 770.4-295-295-116.7 116.7V440.2zM428.2 1624.3V1174L840 1585.8 990.8 1435l621.6-621.6v811H428.2z"
})));
export default SvgCheckbox;